import $ from 'jquery';
export const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

export const requestFetch = async (path, type = "GET", data = null, params = {}, mode = 'json') => {
    const send = Object.assign({}, params, {
        method: type == "GET" ? "GET" : "POST",
        credentials: 'same-origin',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        }
    })
    if (mode == "json") {
        send.headers = {
            ...send.headers,
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
        }
    }

    const createBody = (data, type, mode = "json") => {
        if (mode == "json") {
            if (type == "PUT" || type == "PATCH" || type == "DELETE") {
                data._method = type;
            }
            return JSON.stringify(data)
        } else {
            let formData = new FormData()
            for (let key in data) {
                if (Array.isArray(data[key])) {
                    data[key].forEach(entry => {
                        formData.append(key + '[]', entry)
                    })
                } else {
                    formData.append(key, data[key])
                }
            }
            if (type == "PUT" || type == "PATCH" || type == "DELETE") {
                formData.append("_method", type);
            }
            return formData
        }
    }

    switch (type) {
        case 'GET':
            if (data) {
                let bodyStringify = stringify(data)
                path = `${path}?${bodyStringify}`
            }
            break
        default: {
            const body = createBody(data, type, mode)
            if (type == "PUT" || type == "PATCH" || type == "DELETE") {
                data._method = type;
            }
            Object.assign(send, { body })
        }
    }

    const resp = await fetch(path, send)
    .catch(err => {
        throw new Error(err)
    })
    const respData = await resp.json()
    return {
        ok: resp.ok,
        status: resp.status,
        data: respData,
    }
}

// PC判定
export const isPc = () => {
    return window.matchMedia('(min-width: 768px)').matches;
}

// ゼロ埋め
export const zeroPadding = (num, len = 2) => {
	return ( Array(len).join('0') + num ).slice( -len );
}

// ログインチェック
export const authCheck = () => {
    const authId = document.querySelector('meta[name="auth_id"]').getAttribute('content');
    return authId === '' ? false : authId;
}

export const numberFormat = (num) => {
    return Number(num).toLocaleString();
}

// スクロールイン時に0から表示値までカウントアップさせる際の表示整形（カンマ区切り・小数対応）
const formatCountUpValue = (value, minDigits = 1, decimals = 0) => {
    const fixed = decimals > 0 ? Number(value).toFixed(decimals) : String(Math.round(value));
    const [intPart, decPart] = fixed.split(".");
    const paddedInt = intPart.padStart(minDigits, "0").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return decPart ? `${paddedInt}.${decPart}` : paddedInt;
};

const animateCountUpValue = (el, target, { duration = 1500, minDigits = 1, decimals = 0 } = {}) => {
    const start = performance.now();
    const tick = (now) => {
        const t = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
        el.textContent = formatCountUpValue(target * eased, minDigits, decimals);
        if (t < 1) {
            requestAnimationFrame(tick);
        } else {
            el.textContent = formatCountUpValue(target, minDigits, decimals);
        }
    };
    requestAnimationFrame(tick);
};

// 指定セレクタの要素を、ビューポートに入ったタイミングで0から表示値までカウントアップ表示する
// data-min-digits でゼロ埋め桁数、末尾のテキストが小数の場合は小数桁も保持する
export const setupCountUp = (selector, { delay = 600 } = {}) => {
    const targets = document.querySelectorAll(selector);
    if (!targets.length) return;

    targets.forEach((el) => {
        const raw = el.textContent.trim().replace(/,/g, "");
        const target = parseFloat(raw);
        if (Number.isNaN(target)) return;
        const parsedMinDigits = parseInt(el.dataset.minDigits || "1", 10);
        const minDigits = Number.isNaN(parsedMinDigits) ? 1 : parsedMinDigits;
        const decimalPart = raw.match(/\.(\d+)$/);
        const decimals = decimalPart ? decimalPart[1].length : 0;
        el.dataset.countTo = String(target);
        el.dataset.minDigits = String(minDigits);
        el.dataset.decimals = String(decimals);
        el.textContent = formatCountUpValue(0, minDigits, decimals);
    });

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const el = entry.target;
                if (el.dataset.counted === "1") return;
                el.dataset.counted = "1";
                const target = parseFloat(el.dataset.countTo || "0");
                const minDigits = parseInt(el.dataset.minDigits || "1", 10);
                const decimals = parseInt(el.dataset.decimals || "0", 10);
                if (Number.isNaN(target) || target <= 0) return;
                setTimeout(() => animateCountUpValue(el, target, { minDigits, decimals }), delay);
                observer.unobserve(el);
            });
        },
        { threshold: 0.6 },
    );

    targets.forEach((el) => observer.observe(el));
};

// カウントアップアニメーション
export const countUpAction = (obj, fixCount) => {
    if(fixCount === 0) {
        obj.dataset.hide = '';
    }else{
        delete obj.dataset.hide;
    }
    $(obj).animate({
        Counter: fixCount
    }, {
        duration: 300,
        easing: 'swing',
        step: (now, e) => {
            $(e.elem).text(Math.ceil(now));
        }
    });
}
